import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'


const ProtectRoute = ({ Component }) => {
        const { loading } = useSelector(state => state.user)
        if (!document.cookie.split(';').some((cookie) => cookie.trim().startsWith('gohadmin='))) {
                localStorage.removeItem('admin');
                window.location.href = '/login';
        }
        return (

                !loading ? <Component /> : <Navigate to="/login" />

        )
}
export default ProtectRoute